import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL;

const createFontSettings = async (data) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");

  const settingData = [
    {
      coloum_name: "fonts",
      fontType: data.fontType,
      fontColor: data.fontColor,
      userId: userId || data?.userId,
      link_id: linkId || data?.linkId,
    },
  ];

  const settingDatas = JSON.stringify(settingData);
  const path = `/api/user/createsetting`;
  const url = baseUrl + path;
  const bodyFormData = new FormData();
  bodyFormData.append("setting", settingDatas);
  const response = await axios.post(url, bodyFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `'Bearer'${token}`,
    },
  });
  return response.data;
};

const createAvatarSettings = async (data) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");

  const settingData = [
    {
      coloum_name: "avatar",
      avatar_size: data.avatar_size,
      avatar_shape: data.avatar_shape,
      avatar_outline:data.avatar_outline,
      userId: userId || data?.userId,
      link_id: linkId || data?.linkId,
    },
  ];

  const settingDatas = JSON.stringify(settingData);
  const path = `/api/user/createsetting`;
  const url = baseUrl + path;
  const bodyFormData = new FormData();
  bodyFormData.append("setting", settingDatas);
  const response = await axios.post(url, bodyFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `'Bearer'${token}`,
    },
  });
  return response.data;
};


const createLinkSettings = async (data) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");

  const settingData = [
    {
      coloum_name: "link",
      link_shape: data.link_shape,
      link_outline:data.link_outline,
      link_colors:data.link_colors,
      link_animation:data.link_animation,
      userId: userId || data?.userId,
      link_id: linkId || data?.linkId,
    },
  ];

  const settingDatas = JSON.stringify(settingData);
  const path = `/api/user/createsetting`;
  const url = baseUrl + path;
  const bodyFormData = new FormData();
  bodyFormData.append("setting", settingDatas);
  const response = await axios.post(url, bodyFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `'Bearer'${token}`,
    },
  });
  return response.data;
};


const createBrandingSettings = async (data) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");

  const settingData = [
    {
      coloum_name: "branding",
      branding_title: data.brandingTitle,
      branding_url: data.brandingUrl,
      branding_status: data.brandingStatus,
      branding_isPaid: data.isPaid,
      userId: userId || data?.userId,
      link_id: linkId || data?.linkId,
    },
  ];

  const settingDatas = JSON.stringify(settingData);
  const path = `/api/user/createsetting`;
  const url = baseUrl + path;
  const bodyFormData = new FormData();
  bodyFormData.append("setting", settingDatas);
  const response = await axios.post(url, bodyFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `'Bearer'${token}`,
    },
  });
  return response.data;
};



const createBackgroundSettings = async (data) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");

  const settingData = [
    {
      coloum_name: 'background',
      background_type: data?.background_type,
      background_option_val: data?.background_val,
      userId: userId || data?.userId,
      link_id: linkId || data?.linkId,
    },
  ];

  const settingDatas = JSON.stringify(settingData);

  const path = `/api/user/createsetting`;
  const url = baseUrl + path;
  const bodyFormData = new FormData();
  bodyFormData.append("setting", settingDatas);
  if(data?.background_type === "customImage"){
    bodyFormData.append("picture", data?.background_val);
  }
  const response = await axios.post(url, bodyFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `'Bearer'${token}`,
    },
  });
  return response.data;
};


const createFavSettings = async (data) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");

  const settingData = [
    {
      coloum_name: 'favIcon',
      icon: data?.favicon,
      userId: userId || data?.userId,
      link_id: linkId || data?.linkId,
    },
  ];


  const settingDatas = JSON.stringify(settingData);

  const path = `/api/user/createsetting`;
  const url = baseUrl + path;
  const bodyFormData = new FormData();
  bodyFormData.append("setting", settingDatas);
  bodyFormData.append("fav_file", data?.favIcon);
  const response = await axios.post(url, bodyFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `'Bearer'${token}`,
    },
  });
  return response.data;
};


const createSeoSettings = async (data) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");

  const settingData = [
    {
      coloum_name: 'seo',
      status: data?.metaStatus,
      title: data?.title,
      description: data?.description,
      seo_picture: data?.seoPicture,
      userId: userId || data?.userId,
      link_id: linkId || data?.linkId,
    },
  ];


  const settingDatas = JSON.stringify(settingData);

  const path = `/api/user/createsetting`;
  const url = baseUrl + path;
  const bodyFormData = new FormData();
  bodyFormData.append("setting", settingDatas);
  bodyFormData.append("seo_picture", data?.seoPicture);
  const response = await axios.post(url, bodyFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `'Bearer'${token}`,
    },
  });
  return response.data;
};

const gettingSettingUpdataData = async (state) => {
  
  const userId = JSON.parse(localStorage.getItem('user'))?.userid;
  const linkId = localStorage?.getItem('linkId');
  const path = `/api/user/getsetting`;
  const url = baseUrl + path;
  const data = {
    linkId: linkId || state?.linkData,
    userId: userId || state?.userData,
  };
  const response = await axios.post(url, data);
  return response;
};
// ____________getting_______screenpreview__________setting_________

const getScreenPreviewSetting = async (name) => {
  const path = `/api/user/getSettingData/${name}`;
  const url = baseUrl + path;

  const response = await axios.post(url);

  return response;
};

const appearenceService ={
    createFontSettings,
    gettingSettingUpdataData,
    getScreenPreviewSetting,
    createSeoSettings,
    createBrandingSettings,
    createFavSettings,
    createBackgroundSettings,
    createAvatarSettings,
    createLinkSettings
}
export default appearenceService;